module.exports = __webpack_public_path__ + "assets/images/CADUNFIT50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CADUNFIT50.png
// module id = 1335
// module chunks = 1